import React, { useEffect, useState } from 'react';
import { Popover, ButtonToolbar, OverlayTrigger } from 'react-bootstrap';

import i18next from "i18next";
import { EntityService, TimeFormattingService } from "../../services";
import { EntityGroupingAMTDetail } from '../Grouping';
import { MultiRowSelection } from '../MultiRowSelection';
import { CheckboxInput } from '../CheckboxInput';
import config from "config";

const MonitoringMapView = ({grouping, entities, statusOptions, areaFilterOptions}) => {
  const [currentEntities, setCurrentEntities] = useState(entities);
  const [currentStatusOptions, setCurrentStatusOptions] = useState(statusOptions);
  const [currentAreaFilterOptions, setCurrentAreaFilterOptions] = useState(areaFilterOptions);;
  const [statusIncludeFilter, setStatusIncludeFilter] = useState(null);
  const [areaFilterIncludeFilter, setAreaFilterIncludeFilter] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [refreshTimer, setRefreshTimer] = useState(null);

  const updateEntities = () => {
    EntityService.findAllForGrouping(grouping.id).then(response => {
      setCurrentEntities(response.entities);
      setLastUpdated(TimeFormattingService.renderNow(grouping?.timezone));

      if (autoRefresh) {
        setRefreshTimer(setInterval(updateEntities, 300000));
      }
    }).catch(error => {
      console.error(error);
      // TODO error handler callback...
    });
  };

  useEffect(() => {
    if (autoRefresh) {
      setRefreshTimer(setInterval(updateEntities, 300000));
    }

    return function cleanup() {
      if (refreshTimer) {
        clearInterval(refreshTimer);
        setRefreshTimer(null);
      }
    };
  }, [grouping]);

  const toggleAutoRefresh = () => {
    if (autoRefresh) {
      setAutoRefresh(false);
      if (refreshTimer) {
        clearInterval(refreshTimer);
        setRefreshTimer(null);
      }
    } else {
      setAutoRefresh(true);
      setRefreshTimer(setInterval(updateEntities, 300000));
    }
  }

  const areaFilterUpdated = (updatedAreaFilterOptions) => {
    setCurrentAreaFilterOptions(updatedAreaFilterOptions);
    setAreaFilterIncludeFilter(updatedAreaFilterOptions.filter((area) => area.selected).map((area) => area.id));
  }

  const statusUpdated = (updatedStatusOptions) => {
    setCurrentStatusOptions(updatedStatusOptions);
    setStatusIncludeFilter(updatedStatusOptions.filter((status) => status.selected).map((status) => status.id));
  }

  const statusPopover = (statusOptions, statusUpdated) => (
    <Popover className="filter-map-cat-selection filter-map-popover" id="cri-selection-popover" title={ i18next.t('pages.maps.status') }>
      <MultiRowSelection options={statusOptions} onApplyFilters={statusUpdated} />
    </Popover>
  );

  const areaPopover = (areaFilterOptions, areaFilterUpdated) => (
    <Popover className="filter-map-cat-selection filter-map-popover" id="area-selection-popover" title={ i18next.t('pages.maps.area') }>
      <MultiRowSelection options={areaFilterOptions} onApplyFilters={areaFilterUpdated} />
    </Popover>
  );

  return (
    <div>
      <div className="monitoring-location-map">
        <div className="map-filter-checkbox-wrapper">
          <div className="pull-right">
              <div className="form-group" style={{marginLeft: "-5px"}}>
                <CheckboxInput 
                  input={{ checked: autoRefresh, onChange: toggleAutoRefresh}}
                  label={ i18next.t('form-labels.auto-refresh') }
                  className="inline"
                  meta={{}}
                />
              </div>

              <ButtonToolbar>
                <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={statusPopover(currentStatusOptions, statusUpdated)}>
                  <a className="map-filter-button status-filter"><img src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/filter-status.svg`} alt={ i18next.t('pages.maps.status') } />{ i18next.t('pages.maps.status') }</a>
                </OverlayTrigger>

                <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={areaPopover(currentAreaFilterOptions, areaFilterUpdated)}>
                  <a className="map-filter-button area-filter"><img src={`${config.WEB_BASE_URL}/images/icon/themes/${window.globalBrand}/filter-area.svg`} alt={ i18next.t('pages.maps.area') } />{ i18next.t('pages.maps.area') }</a>
                </OverlayTrigger>
              </ButtonToolbar>
            </div>
        </div>
        <div style={{marginTop: 15}}>

          <EntityGroupingAMTDetail
            statusIncludeFilter={statusIncludeFilter}
            areaFilterIncludeFilter={areaFilterIncludeFilter}
            grouping={grouping}
            entities={currentEntities}
            lastUpdated={lastUpdated}
          />

        </div>
      </div>
    </div>
  );
}

export default MonitoringMapView;
